var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[(_vm.gallery)?_vm._l((_vm.gallery),function(img,index){return _c('div',{key:index,staticClass:"mr-2"},[_c('vue-picture-swipe',{staticClass:"item-thumbnail",attrs:{"items":_vm.getGalleryItem(img)}})],1)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }